import { Injectable } from '@angular/core';
import { shipmentApiService } from '@app/services/api/shipment.service';
import { FlashService } from '@app/services/flash.service';
import {
  Load,
  LoadFail,
  LoadSuccess,
  ShipmentActionsUnion,
  ShipmentActionsTypes
} from '@core/actions/shipment.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, catchError, map, switchMap, exhaustMap } from 'rxjs/operators';

@Injectable()
export class ShipmentEffects {
  constructor(
    private actions$: Actions,
    private shipmentApi: shipmentApiService,
    private fs: FlashService
  ) {}

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ShipmentActionsTypes.Load),
    switchMap(action => {
        return this.shipmentApi.get().pipe(
            map((shipments: any) => {
                // console.log('shipments ===>', shipments)
                return new LoadSuccess(shipments)
            }),
            catchError(error => of(new LoadFail(error)))
        )
    })
  );

/*   @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(ShipmentActionsTypes.LoadSuccess),
    map((action) => {
        this.fs.emit({ type: 'success', message: 'Imagen subida correctamente' });
    })
  );
 */
}
